import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import deleteWholesaler from '@/API/Wholesaler/deleteWholesaler';

const useDeleteWholesaler = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (wholesalerId) => deleteWholesaler(wholesalerId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['wholesalers'] });
            toast.success('Wholesaler deleted successfully');
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.message ||
                    error?.message ||
                    'Failed to delete wholesaler',
            );
        },
    });
};

export default useDeleteWholesaler;
